import { Buffer } from 'buffer';
import axios from 'axios';

export const formatPDF = async (url: string): Promise<string> => {
  const response = await axios.get(url, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/pdf',
      Accept: 'application/pdf',
    },
  });

  const pdfText = Buffer.from(response.data, 'binary').toString('utf-8');
  if (pdfText.includes('pdfBase64')) {
    const pdfJson = JSON.parse(pdfText);
    return pdfJson.pdfBase64;
  }
  return Buffer.from(response.data, 'binary').toString('base64');
};

export const downloadPdf = (base64Pdf: string): void => {
  const encodedUri = encodeURI(base64Pdf);
  const link = document.createElement('a');
  const exportedFilename = 'declaracion.pdf';
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', exportedFilename);
  document.body.appendChild(link);
  link.click();
};

export const downloadCep = async (pdfUrl: string): Promise<void> => {
  const base64Pdf = await formatPDF(pdfUrl);

  const byteCharacters = atob(base64Pdf);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });

  // Crear URL del blob
  const url = window.URL.createObjectURL(blob);

  // Crear elemento link y descargar
  const link = document.createElement('a');
  link.href = url;
  link.download = 'CEP.pdf';
  document.body.appendChild(link);
  link.click();

  // Limpiar
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
